import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

export interface MobileTabItem {
  label: string;
  href: string;
  icon: LucideIcon;
}

interface MobileTabBarProps {
  items: MobileTabItem[];
  className?: string;
}

export function MobileTabBar({ items, className }: MobileTabBarProps) {
  const { pathname } = useLocation();

  return (
    <nav
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50 lg:hidden",
        "border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80",
        "safe-area-inset-bottom",
        className
      )}
    >
      <div className="flex items-stretch justify-around">
        {items.map((item) => {
          const isActive = pathname === item.href || pathname.startsWith(item.href + '/');
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex flex-1 flex-col items-center justify-center gap-1 py-2 min-h-[56px]",
                "transition-colors touch-manipulation",
                isActive
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium leading-none">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
